<template>
    <div>


        <CourseItem v-if="groupHasOnlyOneCourse" :course="courses[0]"></CourseItem>

        <div v-else>
            <div class="spo-card pa-2 rounded my-2" v-if="firstCourse">
                <v-row>
                    <v-col>
                        <div class="text-h5 font-weight-bold">{{ groupName }}</div>
                        <div v-if="display_depart">
                            Départ : {{ date_depart }} {{ heure_depart }}
                        </div>
                        <CourseProperties :course="firstCourse"></CourseProperties>
                        <CourseInformationsTruncated :text="firstCourse.metadatas.indications" :maxLines="3"
                            class="mt-2" />
                    </v-col>
                    <v-col cols="12" lg="3" xl="2">
                        <div v-if="show_inscription_button(firstCourse)">
                            <SportipsButton @onClick="openSelectionModal()" icon="mdi-pencil-plus-outline" chevron
                                action-button full-width>
                                S'inscrire
                            </SportipsButton>
                            <TarifsCourse :tarifs="firstCourse.tarifs" :course="firstCourse" withoutPerPerson="1">
                            </TarifsCourse>
                        </div>
                        <div v-else
                            class="d-flex align-center justify-center ga-1 bg-dark-red text-white rounded py-2 px-1 font-weight-600 cursor-disabled">
                            <v-icon icon="mdi-pencil-off-outline"></v-icon>
                            {{ get_inscription_closed_text() }}
                        </div>

                    </v-col>
                </v-row>
                <!-- <div class="my-2">Formats de relais disponibles:</div>
                <v-row>
                    <v-col cols="12" sm="6" lg="4" xl="4" v-for="course in courses" :key="course.id">
                        <div class="bg-white bordered rounded p-2">
                            <div class="font-weight-bold text-center">{{ course.nom }}</div>
                            <TarifsCourse :tarifs="course.tarifs" :course="course"></TarifsCourse>
                        </div>

                    </v-col>
                </v-row> -->
            </div>
        </div>

        <!-- Modal de sélection de course -->
        <v-dialog v-model="showSelectionModal" max-width="600px">
            <v-card class="pa-2">
                <v-card-title>
                    <div class="text-h5 font-weight-bold text-darkblue">Sélectionnez le format</div>
                </v-card-title>
                <v-card-text class="pa-2">

                    <div v-for="course in courses" :key="course.id" @click="selectCourse(course)"
                        class="d-flex align-center ga-2 mb-2 rounded cursor-pointer bordered spo-card p-2"
                        :class="{ 'bg-darkblue text-white': selectedCourse && selectedCourse.id === course.id }">

                        <v-icon
                            :icon="selectedCourse && selectedCourse.id === course.id ? 'mdi-check' : 'mdi-crop-square'"
                            color="primary"></v-icon>
                        <div class="font-weight-bold">{{ course.nom }}</div>
                    </div>
                </v-card-text>
                <v-card-actions>

                    <v-btn color="darkblue" variant="text" @click="closeSelectionModal">
                        Annuler
                    </v-btn>
                    <v-btn color="darkblue" variant="elevated" elevation="0" :disabled="!selectedCourse"
                        @click="confirmCourseSelection">
                        S'inscrire
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
import CourseItem from "@/components/Home/Courses/Course_Item.vue";
import CourseProperties from "@/components/Home/Courses/Course_Properties.vue";
import TarifsCourse from "@/components/Home/Courses/Tarifs_Course.vue";
import CourseInformationsTruncated from "@/components/Home/Courses/CourseInformationsTruncated.vue";
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
export default {
    components: { CourseItem, CourseProperties, TarifsCourse, CourseInformationsTruncated },
    props: {
        courses: {
            type: Array,
            required: true
        },
        groupName: {
            type: String,
            required: true
        }
    },
    computed: {
        ...mapStores(useMainStore),
        display_depart() {
            return this.firstCourse.display_depart_on_home();
        },
        date_depart() {
            return this.firstCourse.get_readable_date_depart();
        },
        heure_depart() {
            return this.firstCourse.get_readable_heure_depart();
        },
        firstCourse() {
            if (this.courses.length === 0) {
                return null;
            }
            if (this.courses[0] && this.courses[0].id) {
                return this.courses[0];
            }

            return null;
        },
        groupHasOnlyOneCourse() {
            return this.courses.length === 1;
        },
    },
    data() {
        return {
            showSelectionModal: false,
            selectedCourse: null
        }
    },
    methods: {
        show_inscription_button(course) {

            const course_selectionable = course.is_selectionnable(
                this.mainStore.module.status,
                this.mainStore.view_as_admin,
                this.mainStore.inscription_as_admin,
                this.mainStore.inscription_vip,
                this.mainStore.module.courses,
                this.mainStore.module.is_complet,

                this.mainStore.bookingSystem?.groupe
            );

            return course_selectionable;
        },
        get_inscription_closed_text() {
            if (this.mainStore.module.status == 'avant_ouverture') {
                return 'A venir';
            }
            else if (this.mainStore.module.status == 'apres_fermeture') {
                return 'Fermé';
            }
            else if (this.firstCourse.is_complet(this.all_courses)) {
                return 'Complet';
            }
            else if (this.mainStore.module.is_complet) {
                return 'Complet';
            }
            else {
                return 'Inscriptions closes';
            }
        },
        /* Si clic sur button _s'inscrire_ on ajoute en mémoire la préselection pour l'ajouter à la sélection de parcours du premier coureur en page suivante */
        async addToPreselection(course) {
            this.mainStore.bookingSystem.preselection = { type: "course", value: course.id, course: course };

            this.$router.push({ name: "Inscriptions" });
        },
        openSelectionModal() {
            this.showSelectionModal = true;
            this.selectedCourse = null;
        },
        closeSelectionModal() {
            this.showSelectionModal = false;
            this.selectedCourse = null;
        },
        selectCourse(course) {
            this.selectedCourse = course;
        },
        confirmCourseSelection() {
            if (this.selectedCourse) {
                this.addToPreselection(this.selectedCourse);
                this.closeSelectionModal();
            }
        },
    }
}

</script>

<style lang="scss" scoped></style>